<template>
  <div>
    <div class="slider_range_count mt_6">
      <span class="text_12">{{ min }}</span>
      <span class="text_14 font_600 text_purple_primary">{{ value }}</span>
      <span class="text_12">{{ max }}</span>
    </div>
    <input
      v-model.number="internalValue"
      class="slider_range"
      type="range"
      :min="min"
      :max="max"
      :step="step"
    />
  </div>
</template>

<script>
export default {
  name: 'SliderRangeInput',
  props: {
    value: {
      type: Number,
      required: true
    },
    min: {
      type: Number,
      default: 0
    },
    max: {
      type: Number,
      default: 1
    },
    step: {
      type: Number,
      default: 0.01
    }
  },
  computed: {
    internalValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~dashboard/assets/scss/widgets/_fonts.scss';

.slider_range {
  width: 100%;
  appearance: none;
  height: 6px;
  background-color: transparent;
  border-radius: 3px;
  margin: 0;
  padding: 0;
}

.slider_range::-webkit-slider-runnable-track {
  height: 6px;
  background-color: var(--w-500);
  border-radius: 3px;
}

.slider_range::-webkit-slider-thumb {
  appearance: none;
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 2px solid var(--w-500);
  border-radius: 50%;
  margin-top: -5px;
  cursor: pointer;
  position: relative;
}

.slider_range::-moz-range-track {
  height: 6px;
  background-color: var(--w-500);
  border-radius: 3px;
}

.slider_range::-moz-range-thumb {
  width: 16px;
  height: 16px;
  background-color: #fff;
  border: 2px solid var(--w-500);
  border-radius: 50%;
  cursor: pointer;
  position: relative;
  top: -5px;
}

.slider_range_count {
  display: flex;
  justify-content: space-between;
}
</style>
